import React from "react";
import styles from "./ServicesCards.module.scss";
import { useNavigate } from "react-router-dom";
const cardData = [
  {
    id: 1,
    icon: "",
    title: "Consulting & Implementation",
    description:
      "Unsure of your business needs? SealKloud can help you customize SAP solutions that will fill in the gaps of your business requirements.",
    slug: "/services/consulting",
  },
  {
    id: 2,
    icon: "",
    title: "Project Management",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/project-management",
  },
  {
    id: 3,
    icon: "",
    title: "Cloud Migration",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/cloud-migration",
  },
  {
    id: 4,
    icon: "",
    title: "Robotic Process Automation",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/rpa",
  },
  {
    id: 5,
    icon: "",
    title: "SME Advisory",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/sme-advisory",
  },
  {
    id: 6,
    icon: "",
    title: "Testing",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/testing",
  },
  {
    id: 6,
    icon: "",
    title: "SAP S4 HANA On Premise / Cloud",
    description:
      "As one of the leading SAP services companies, SealKloud provides excellent after-production support that can be used to solve any problems you’re facing.",
    slug: "/services/sap-s4-hana",
  },
];

const Card = ({ icon, title, description,slug }) => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route); // Navigate to the specified route
  };
  return (
    <div className={styles.card}>
      <div className={styles.icon}>{icon}</div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
      <button className={styles.button} onClick={() => handleNavigation(slug)}>
        Read More
      </button>
    </div>
  );
};

const ServicesCards = () => (
  <div className={styles.cardList}>
    {cardData.map((card) => (
      <Card
        key={card.id}
        icon={card.icon}
        title={card.title}
        description={card.description}
        slug={card.slug}
      />
    ))}
  </div>
);

export default ServicesCards;
